// extracted by mini-css-extract-plugin
module.exports = {"continer":"scrolls_continer_1cebg","refresh":"scrolls_refresh_1TDKV"};